module.exports = __webpack_public_path__ + "static/media/electronics-big.8e6d0e93.png";